import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Wrapper from "../../components/Wrapper";
import { Inquiry } from '../../models/inquiry';
import BTable from 'react-bootstrap/Table';
import Pagination from '../../components/pagination/index';
import { RiDeleteBinLine } from 'react-icons/ri';
import moment from 'moment';

const Inquiries = () => {
    const [inquiries, setInquiries] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [searchText, setSearchValue] = useState('');
    const [inquiry_cnt, setInquiriesCount] = useState(0);
    // console.log("Inquires123");

    useEffect(() => {
        // console.log("Inquires123");
        const fetchInquiries = async () => {
            setLoading(true);
            const { data } = await axios.get(`inquiry?page=${currentPage}&size=${itemsPerPage}&keyword=${searchText}`);
            setInquiriesCount(data.length);
            setInquiries(data);
            setLoading(false);
        };
        // console.log("Inquires");
        
        fetchInquiries();
    }, [currentPage, itemsPerPage, searchText]);

    /* const del = async (id: number) => {
        if (window.confirm('Are you sure you want to delete?')) {
            try {
                await axios.delete(`inquiry/${id}?page=${currentPage}&size=${itemsPerPage}&keyword=${searchText}`).then((res)=>{
console.log(res);
                });
                
                
                setInquiries(inquiries.filter((r: Inquiry) => r.id !== id));
            } catch (error: any) {
                console.log(`${error.response.status}: ${error.response.message}`);
            }
        }
    }; */

    const del = async (id: number) => {
        if (window.confirm('Are you sure you want to delete?')) {
            try {
                await axios.delete(`inquiry/${id}?page=${currentPage}&size=${itemsPerPage}&keyword=${searchText}`);
                setInquiries(inquiries.filter((r: Inquiry) => r.id !== id));
            } catch (error: any) {
                console.log(`${error.response.status}: ${error.response.message}`);
            }
        }
    };

    const handlePageChange = (pageNumber: number) => {
        setCurrentPage(pageNumber);
    };

    const handleItemsPerPageChange = (itemsPerPage: number) => {
        setItemsPerPage(itemsPerPage);
        setCurrentPage(1);
    };
    return (
        <Wrapper>
            <div className="CardPedboxCover">
                <div className='AdmintopTitleCov'>
                    <div className='AdmintopTitleLeft'>
                        <h1>Inquiries</h1>
                    </div>
                </div>
                <>
                    <div className='ComTableCardCov'>
                        <BTable striped bordered hover size="sm">
                            <thead>
                                <tr>
                                    <th style={{ width: 35 }}></th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Mobile</th>
                                    <th>Form Name</th>
                                    <th>Subject</th>
                                    <th>Message</th>
                                    <th>Created</th>
                                    <th>Action</th>
                                    <th style={{ width: 35 }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td></td>
                                        <td colSpan={6}>Loading...</td>
                                        <td></td>
                                    </tr>
                                ) : (
                                    <>
                                        {inquiries.length > 0 ? (
                                            inquiries.map((inq: Inquiry) => {
                                                const isoDate = inq.created_at;
                                                const formatted = moment(isoDate).format('DD MMM YYYY hh:mm:ss A');
                                                return (
                                                    <tr key={inq.id}>
                                                        <td></td>
                                                        <td>{inq.firstName} { inq.lastName } </td>
                                                        <td>{inq.email} </td>
                                                        <td>{inq.phoneCode} {inq.mobileNumber} </td>
                                                        <td>{inq.formName} </td>
                                                        <td>{inq.subject} </td>
                                                        <td>{inq.message} </td>
                                                        <td>{formatted} </td>
                                                        <td>
                                                            <button type="button" className="DownloadPageBtnCov" onClick={() => del(inq.id)}><RiDeleteBinLine /></button>
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                )
                                            })) : (
                                            <tr>
                                                <td></td>
                                                <td colSpan={2}>No data found</td>
                                                <td></td>
                                            </tr>
                                        )}
                                    </>
                                )}
                            </tbody>
                        </BTable>
                    </div>
                </>
                <div className='PaginationCustbox PaginationCusUser'>
                    <Pagination
                        totalItems={inquiry_cnt}
                        currentPage={currentPage}
                        itemsPerPage={itemsPerPage}
                        onPageChange={handlePageChange}
                        onItemsPerPageChange={handleItemsPerPageChange}
                    />
                </div>
            </div>
        </Wrapper>
    );
};

export default Inquiries;